// extracted by mini-css-extract-plugin
export var aircallIframe = "_hq-3";
export var fabContainer = "_hq-5";
export var fabRinging = "_hq-6";
export var loadingOverlay = "_hq-4";
export var pulse = "_hq-7";
export var widgetContent = "_hq-2";
export var widgetPanel = "_hq-0";
export var widgetPanelExpanded = "_hq-1";